import { AppBar, Box, CssBaseline, Toolbar, Typography } from "@material-ui/core"
import { useStyles } from "./navbar-styles";
import { useRef } from "react";
import { CardLogout } from "../cards/card-logout";
import { CardLogoutRef } from "../cards/card-logout/card-logout";
import { useKdsToken } from "../../../services/app";
import { PublicPageHeader } from "../headers/header-public-page/header-public-page";
import clsx from 'clsx';
import MenuIcon from '@material-ui/icons/Menu';
import { useMenuPrincipal } from "../../../services/app/providers/menu-principal-provider";
import { VoltarIcon } from "../icons";
import { ButtonNavbar } from "../buttons/button-navbar/button-navbar";

export type NavbarProps = {
  titulo?: string,
  buttonBack?: boolean,
  voltar?: () => void;
  rightArea?: React.ReactNode
}

export const Navbar = ({ titulo, buttonBack, voltar, rightArea }: NavbarProps) => {
  const classes = useStyles();
  const { getTokenFromStorage } = useKdsToken();
  const { abrirMenu } = useMenuPrincipal()
  const cardlogoutRef = useRef<CardLogoutRef>(null);

  return (
    <>
      <PublicPageHeader topOpacity="0.8" />
      <CardLogout ref={cardlogoutRef} />
      <div>
        <CssBaseline />
        <AppBar position="relative" className={clsx(classes.appBar)}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex" alignItems="center">
              <Toolbar>
                <ButtonNavbar className={classes.buttonNavbar} onClick={buttonBack ? voltar : abrirMenu}>
                  {buttonBack ? (
                    <VoltarIcon tipo="BUTTON_PRIMARY" />
                  ) : (
                    <MenuIcon />
                  )}
                </ButtonNavbar>
                <Typography variant="h6" noWrap>
                  {titulo && titulo.length > 0 ? titulo : getTokenFromStorage()?.saudacao}
                </Typography>
              </Toolbar>
            </Box>
            {rightArea && rightArea}
          </Box>
        </AppBar>
      </div>
      <div>
      </div>
    </>


  );
};

